module.exports = __webpack_public_path__ + "static/img/i157.bcb36407.png";